const wppClickObservable = {
    init: function() {
        if (!!!this.component.length) {
            return
        }
  
        this.addEventListeners()
    },
  
    addEventListeners: function() {
        this.component.forEach(link => {
            link.addEventListener('click', this.handleClick.bind(this))
        })
    },
  
    handleClick: function(e) {
        e.preventDefault()

        const regexUrl = /\d+/;

        const href = e.currentTarget.getAttribute('href')

        let result = href.match(regexUrl)

        const isInsidePopup = e.currentTarget.closest('#popup-whatsapp') !== null;

        const urlPopup = isInsidePopup ? this.$popup_text : ''

        const url = this.isMobile ? `https://wa.me/${result[0]}?${urlPopup}` : `https://web.whatsapp.com/send?phone=${result[0]}&${urlPopup}`
        
        window.open(url, '_blank')
    },
  
    component: document.querySelectorAll('a[href*="wa.me/"], a[href*="web.whatsapp"]'),
    isMobile: window.innerWidth < 1000,
    $popup_text: 'text=Olá,%20quero%20saber%20mais%20sobre%20a%20Superpromo',

    update: function() {
        this.component = document.querySelectorAll('a[href*="wa.me/"], a[href*="web.whatsapp"]');
        this.addEventListeners();
    }

}

wppClickObservable.init();


jQuery(document).ready(function($) {
    wppClickObservable.update();

    $(document.body).on('updated_wc_div', function() {
        wppClickObservable.update();
    });

    $('.btn-next').on('click', function() {
        wppClickObservable.update();
    });
});


